import { useMutation } from 'react-query'

import { tfaService } from '@/modules/profile-settings/service/tfa-service.tsx'

export function useDisableTfa() {
  return useMutation('tfa-disable', tfaService.disableTfa)
}
